import SubLinks from './SubLinks.jsx';
import { reportingLinksForUser } from '../../config/standard-links.js';
import useCurrentUser from '../../hooks/useCurrentUser.js';

/**
 * Reporting section nav; omits Audit Tickets unless user is team lead or IT leadership.
 */
const ReportingSubLinks = () => {
    const { loading, canAccessWeeklyAudit, executivePulseAccess } =
        useCurrentUser();
    const links = reportingLinksForUser({
        loading,
        canAccessWeeklyAudit,
        executivePulseAccess
    });
    return <SubLinks links={links} />;
};

export default ReportingSubLinks;
